import SignalTable from 'components/global/SignalTable/SignalTable';
import { $list, $view } from 'signals/global.signals';
import useEffectAsync from 'utils/useEffectAsync';
import SimpleCard from 'components/global/SimpleCard';
import { handleClickEditPerson } from 'components/views/InvestorTeam/_helpers/investorTeam.events';
import InvestorEditPersonModal from './InvestorEditPersonModal';
import InvestorPersonDeleteModal from './InvestorPersonDeleteModal';
import InvestorPersonRows from './InvestorPersonRows';
import { fetchAndSetOrganizationUsers } from '../_helpers/investorTeam.resolvers';

const InvestorPeople = () => {
  useEffectAsync(fetchAndSetOrganizationUsers);
  return (
    <>
      <SimpleCard>
        <SignalTable
          headers={[{
            key: 'name',
            value: 'Name',
          }, {
            key: 'email',
            value: 'Email',
          }, {
            key: 'Roles',
            value: 'Roles',
          },
          {
            key: 'Teams',
            value: 'Teams',
          }, {
            key: 'Actions',
            value: 'Actions',
          }]}
          rows={InvestorPersonRows({ data: $list.value.data || [] })}
          isLoading={$view.value.isTableLoading}
          onRowClick={(row) => handleClickEditPerson(row)}
        />
      </SimpleCard>
      <InvestorEditPersonModal />
      <InvestorPersonDeleteModal />
    </>
  );
};

export default InvestorPeople;
